import {
  Acura,
  AlfaRomeo,
  Audi,
  BMW,
  Buick,
  Cadillac,
  Chevrolet,
  Chrysler,
  Dodge,
  Fiat,
  Fisker,
  Ford,
  Genesis,
  GMC,
  Honda,
  Hyundai,
  Ineos,
  Infiniti,
  Jaguar,
  Jeep,
  Kia,
  LandRover,
  Lexus,
  Lincoln,
  Lucid,
  Maserati,
  Mazda,
  MercedesBenz,
  Mercury,
  Mini,
  Mitsubishi,
  Nissan,
  Polestar,
  Pontiac,
  Porsche,
  Ram,
  Rivian,
  Saab,
  Saturn,
  Scion,
  Smart,
  Subaru,
  Suzuki,
  Tesla,
  Toyota,
  Volkswagen,
  Volvo
} from '@carvana/ds-icons';
import React from 'react';

const MAKE_LOGOS: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  acura: Acura,
  alfaromeo: AlfaRomeo,
  audi: Audi,
  bmw: BMW,
  buick: Buick,
  cadillac: Cadillac,
  chevrolet: Chevrolet,
  chrysler: Chrysler,
  dodge: Dodge,
  fiat: Fiat,
  fisker: Fisker,
  ford: Ford,
  genesis: Genesis,
  gmc: GMC,
  honda: Honda,
  hyundai: Hyundai,
  ineos: Ineos,
  infiniti: Infiniti,
  jaguar: Jaguar,
  jeep: Jeep,
  kia: Kia,
  landrover: LandRover,
  lexus: Lexus,
  lincoln: Lincoln,
  lucid: Lucid,
  maserati: Maserati,
  mazda: Mazda,
  mercedesbenz: MercedesBenz,
  mercury: Mercury,
  mini: Mini,
  mitsubishi: Mitsubishi,
  nissan: Nissan,
  polestar: Polestar,
  pontiac: Pontiac,
  porsche: Porsche,
  ram: Ram,
  rivian: Rivian,
  saab: Saab,
  saturn: Saturn,
  scion: Scion,
  smart: Smart,
  subaru: Subaru,
  suzuki: Suzuki,
  tesla: Tesla,
  toyota: Toyota,
  volkswagen: Volkswagen,
  volvo: Volvo
};

interface MakeLogoProps {
  make?: string | null;
  size?: number;
}

const getLogo = (make?: string | null) =>
  make ? MAKE_LOGOS[make.toLowerCase().replace(/[^a-z]/gi, '')] : undefined;

export const hasMakeLogo = (make?: string | null) => !!getLogo(make);

const MakeLogo = ({ make, size = 32 }: MakeLogoProps) => {
  const Logo = getLogo(make);

  if (!Logo) return null;

  return <Logo width={size} height={size} aria-hidden />;
};

export default MakeLogo;
